import React from 'react';

interface StackAuthProviderProps {
  children: React.ReactNode;
}

export function StackAuthProvider({ children }: StackAuthProviderProps) {
  // Legacy name kept for compatibility; now simply returns children.
  return <>{children}</>;
}

// Preferred modern name to clarify we use local auth now
export const AuthProvider = StackAuthProvider;
